export default __webpack_public_path__ + "static/media/img3.eee91876.png";